/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count words & characters`)
};

const es_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta palabras y caracteres`)
};

const de_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zählen Sie Wörter und Zeichen`)
};

const nl_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel woorden en tekens`)
};

const fr_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez les mots et les caractères`)
};

const it_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta parole e caratteri`)
};

const pt_br2_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contar palavras e caracteres`)
};

const pt_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contar palavras e caracteres`)
};

const ja_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語と文字をカウント`)
};

const zh_wc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计字数与字符数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_nav_main_desc", locale)
	if (locale === "en") return en_wc_nav_main_desc(inputs)
	if (locale === "es") return es_wc_nav_main_desc(inputs)
	if (locale === "de") return de_wc_nav_main_desc(inputs)
	if (locale === "nl") return nl_wc_nav_main_desc(inputs)
	if (locale === "fr") return fr_wc_nav_main_desc(inputs)
	if (locale === "it") return it_wc_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_wc_nav_main_desc(inputs)
	if (locale === "pt") return pt_wc_nav_main_desc(inputs)
	if (locale === "ja") return ja_wc_nav_main_desc(inputs)
	return zh_wc_nav_main_desc(inputs)
};